module.exports = __webpack_public_path__ + "static/media/popcorn-happy-new.1d8ee084.png";